
import CompanyAppService from "@/apis.machine/CompanyAppService";
import CurrentLogier from "@/apis/CurrentLogier";
import { MiezzMenuTab } from "@/components/MiezzMenuTab.vue";
import DtoDetailCompanyCreditAndAccountPeriod, {
  DtoDetailCompanyCreditAndAccountPeriodMiezzDetailItems,
} from "@/models.machine/DtoDetailCompanyCreditAndAccountPeriod";
import DtoDetailCompanyLadingBillTemplate, {
  DtoDetailCompanyLadingBillTemplateMiezzDetailItems,
} from "@/models.machine/DtoDetailCompanyLadingBillTemplate";
import DtoDetailCompanyLadingBillTemplate_CompanyLadingBillTemplate, {
  DtoDetailCompanyLadingBillTemplate_CompanyLadingBillTemplateMiezzListItems,
} from "@/models.machine/DtoDetailCompanyLadingBillTemplate_CompanyLadingBillTemplate";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm from "@/models/MiezzForm";
import MiezzPageList from "@/models/MiezzPageList";
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
export default class CustomerServiceProviderCompanyCreditAndAccountingPeriodDetail extends Vue {
  detail = new MiezzForm<DtoDetailCompanyCreditAndAccountPeriod, string>();
  id?: string;
  buttons: MiezzButton[] = [
    {
      Code: "back",
      Label: "返回",
      MiezzIcon: "back",
      Type: "text",
      Size: "small",
    },
    {
      Code: "edit",
      Label: "编辑",
      Icon: "edit",
      Type: "text",
      Size: "small",
    },
  ];
  menuTab = new MiezzMenuTab();
  loading = true;

  created(): void {
    this.menuTab.Url = this.$route.path;
    this.menuTab.Back = true;
    this.menuTab.Menus = [
      {
        Url: this.menuTab.Url,
        Label: "授信与账期",
        Power:
          "CustomerManagement_ServiceProvider_Company_CreditAndAccountingPeriod",
      },
    ];
    this.id = this.$route.params.id as string;
    this.detail.Data = new DtoDetailCompanyCreditAndAccountPeriod();
    this.detail.Items = DtoDetailCompanyCreditAndAccountPeriodMiezzDetailItems;

    this.handleGet();
  }

  handleGet(): void {
    this.loading = true;
    CompanyAppService.GetCreditAndAccountPeriodById(this.id).then((r) => {
      if (r.data.Data) {
        this.detail.Data = r.data.Data;
        this.loading = false;
        //   if (this.list.Data) this.list.Data.Items = r.data.Data.LadingBillTemplates;
      }
    });
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "edit":
        this.$router.push(
          `/customer/company/service-provider/credit-and-accounting-period/edit/${this.id}`
        );
        complete();
        break;
      case "back":
        CurrentLogier.Back();
        complete();
        break;
      default:
        break;
    }
  }
}
